module.exports = __webpack_public_path__ + "static/media/in_a_week_5.d85f0492.jpg";